import {
  QuestionnaireProgressTab,
  QuestionnaireProgressTabProps,
} from '@backrs_ui/common-ui/src/atoms/QuestionnaireProgressTab';

import { Box, SxProps, Theme } from '@mui/material';

type QuestionnaireProgressTabsProps = Readonly<{
  tabs: QuestionnaireProgressTabProps[];
  activeTabId: string | undefined;
  activeSubcategoryId: string | undefined;
  onSubcategoryClick?: (tabId: string, subcategoryId: string) => void;
  showSubcategories?: boolean;
}>;

export const QuestionnaireProgressTabs = ({
  tabs,
  activeTabId,
  activeSubcategoryId,
  onSubcategoryClick,
  showSubcategories = true,
}: QuestionnaireProgressTabsProps) => {
  const handleTabClick = (tab: QuestionnaireProgressTabProps) => {
    if (onSubcategoryClick && tab.subcategories.length > 0) {
      // clicking the tab does the same thing as clicking the first subcategory
      onSubcategoryClick(tab.title, tab.subcategories[0].id);
    }
  };

  return (
    <Box sx={containerSx}>
      {tabs.map((tab) => (
        <QuestionnaireProgressTab
          key={tab.title}
          title={tab.title}
          subcategories={tab.subcategories}
          highlighted={tab.highlighted}
          active={activeTabId === tab.title}
          activeSubcategoryId={activeTabId === tab.title ? activeSubcategoryId : undefined}
          onSubcategoryClick={(subcategoryId) => onSubcategoryClick?.(tab.title, subcategoryId)}
          onTabClick={() => handleTabClick(tab)}
          showSubcategories={showSubcategories}
        />
      ))}
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: { xs: backrs.spacing['spacing-3xl'], md: backrs.spacing['spacing-4xl'] },
  backgroundColor: backrs.colors['Beige/25'],
  width: '100%',
  justifyContent: { xs: 'flex-start', md: 'center' },
  overflowX: 'auto',
  // target medium size tablets
  '@media screen and (max-width: 1205px) and (max-height: 768px)': {
    justifyContent: 'space-between',
  },
});
